<template>
  <home/>
</template>

<script>
import home from "@/components/home.vue";

export default
{
    name: "App",
    components:
    {
        home,
    },
};
</script>

<style lang="scss">
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
